/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

function Loading() {
  return (
    <div className="w-full h-full flex flex-col justify-center items-center gap-5">
      <span className="loader w-[200px] h-[200px] rounded-full border-t-4 border-b-4 border-green-500 animate-spin" />
      <p className="text-xl animate-[ping_1.5s_ease-in-out_infinite] anim">
        Loading...
      </p>
    </div>
  );
}

export default Loading;
